import styled, { css } from "styled-components/native";
import { StyledProps } from "./types";

export const BetTypesTouchable = styled.TouchableHighlight<StyledProps>`
  height: 100%;
  padding: ${({ theme }: StyledProps) =>
    `${theme.space["space-6"]} ${theme.space["space-4"]}`};
  border-top-color: ${({ theme }: StyledProps) =>
    theme.colorTokens.background.surface};
  border-top-width: 2px;
  ${({ isHovered, theme }: StyledProps) =>
    isHovered &&
    css`
      background-color: ${theme.colorTokens.component.button.buttonLink
        .background.hover};
    `}

  ${({ isPressed, theme }: StyledProps) =>
    isPressed &&
    css`
      background-color: ${theme.colorTokens.component.input.pressed};
      border-bottom-color: ${theme.colorTokens.content.link};
      border-bottom-width: 2px;
    `}
  
  ${({ isSelected, theme }: StyledProps) =>
    isSelected &&
    css`
      border-bottom-color: ${theme.colorTokens.content.link};
      border-bottom-width: 2px;
    `};
`;

export const BetTypesText = styled.Text<StyledProps>`
  color: ${({ theme }: StyledProps) => theme.colorTokens.content.default};
  font-family: ${({ theme }: StyledProps) => theme.fonts.medium};
  font-size: ${({ theme }: StyledProps) => theme.fontSizes.s};
  text-align: center;
  ${({ isSelected, isPressed, theme }: StyledProps) =>
    (isSelected || isPressed) &&
    css`
      color: ${theme.colorTokens.content.link};
    `};
`;
